import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { actionCreators } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => ({
	...mapParentStateToProps(state, props),
	currentStep: ANAMNESIS_VIEWS.SELECT_COACH,
	introTitle: i18n('react.impulsCoach.components.anamnesis.selectCoach.introTitle'),
	introText: i18n('react.impulsCoach.components.anamnesis.selectCoach.introText'),
	title: i18n('react.impulsCoach.components.anamnesis.selectCoach.title'),
	coaches: [
		{
			id: 'LEO' as 'LEO',
			name: i18n('react.impulsCoach.components.coachSelector.LEO.name'),
		},
		{
			id: 'MIA' as 'MIA',
			name: i18n('react.impulsCoach.components.coachSelector.MIA.name'),
		},
	],

	actionButtonsInactive: {
		buttons: [
			{
				type: 'disabled',
				labelBottom: i18n('react.impulsCoach.components.anamnesis.saveCaption'),
				knob: {
					modifier: 'dashed',
					icon: 'completed',
					size: 'l',
				},
			},
		],
	},
	actionButtonsActive: {
		buttons: [
			{
				labelBottom: i18n('react.impulsCoach.components.anamnesis.saveCaption'),
				knob: {
					modifier: 'dashed',
					icon: 'completed',
					size: 'l',
				},
			},
		],
	},
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type SelectCoachContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
